export default "__VITE_ASSET__BOD_DfHh__"